import { render, staticRenderFns } from "./unSubmitted.vue?vue&type=template&id=9f4eddb4&scoped=true"
import script from "./unSubmitted.vue?vue&type=script&lang=js"
export * from "./unSubmitted.vue?vue&type=script&lang=js"
import style0 from "./unSubmitted.vue?vue&type=style&index=0&id=9f4eddb4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f4eddb4",
  null
  
)

export default component.exports